module.exports = __webpack_public_path__ + "c641dbee1d75892e4d88bdc31560c91b.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/public/fonts/Montserrat/Montserrat-SemiBold.ttf
// module id = 1804
// module chunks = 1